import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { GenericTableComponent } from '../../../global/component/generic/generic-table/generic-table.component';
import { TableModule } from "primeng/table";

@Component({
  selector: 'app-campaign-settings-search-throttle',
  standalone: true,
  imports: [ToastModule, CardModule, InputTextModule, ToggleButtonModule, GenericButtonComponent, GenericTableComponent, TableModule ],
  templateUrl: './campaign-settings-search-throttle.component.html',
  styleUrl: './campaign-settings-search-throttle.component.scss'
})
export class CampaignSettingsSearchThrottleComponent {

}
